module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 558
 ** module chunks = 1
 **/